import Layout from '@/components/layout/index.vue'
export default {
  path: 'orderdelivery',
  name: 'Orderdelivery',
  meta: {},
  component: Layout,
  redirect: { name: 'Orderdelivery.Parameter' },
  children: [
    {
      path: 'tracking',
      name: 'Orderdelivery.Tracking',
      meta: {},
      component: () => import(/* webpackChunkName: "orderdelivery" */ '@/views/supplier/orderdelivery/tracking/index.ts')
    },
    {
      path: 'supnewTrace',
      name: 'Orderdelivery.SupnewTrace',
      meta: {},
      component: () => import(/* webpackChunkName: "orderdelivery" */ '@/views/supplier/orderdelivery/newTrace/index.ts')
    },
    {
      path: 'suplookdajiao',
      name: 'Orderdelivery.Suplookdajiao',
      meta: { title: 'common.checkAcceptance', dep: 'Orderdelivery.SupnewTrace' },
      component: () => import(/* webpackChunkName: "orderdelivery" */ '@/views/supplier/orderdelivery/newTrace/lookdajiao.vue')
    },
    {
      path: 'supAcceptance',
      name: 'Orderdelivery.SupAcceptance',
      meta: { title: 'common.accept', dep: 'Orderdelivery.SupnewTrace' },
      component: () => import(/* webpackChunkName: "orderdelivery" */ '@/views/supplier/orderdelivery/newTrace/supAcceptance.vue')
    }
  ]
}
